const buttonColor = {
  lineNormal: "#d4d9e1",
  lineHover: "#c2cad4",
  linePressed: "#858c97",
  lineDisabled: "#c2cad4",
  lineNormalText: "#606060",
  lineHoverText: "#aaaaaa",
  linePressedText: "#505050",
  redNormal: "#f42d16",
  redHover: "#f65745",
  redPressed: "#db2813",
  redDisabled: "#fa958a",
  blueNormal: "#00c7c7",
  blueHover: "#0ddddd",
  bluePressed: "#009a9a",
  blueDisabled: "#b2f2f2",
  whiteNormal: "#ffffff",
  whiteHover: "#f5f5f5",
  whitePressed: "#dfe3e9",
  whiteDisabled: "#ffffff",
};

const color = {
  textColor: "#2f2f38",
  bgColor: "#f6f6f8",
  white: "#ffffff",
  yellow: "#ffb100",
  gray900: "#1e1e1e",
  gray800: "#333333",
  gray700: "#505050",
  gray600: "#606060",
  gray500: "#808080",
  gray400: "#aaaaaa",
  gray300: "#d3d3d3",
  gray200: "#ebebeb",
};

export const theme = {
  buttonColor,
  color,
};

export type Theme = typeof theme;
